module.exports = __webpack_public_path__ + "img/logo_wh.76de64de.png";